import { type ReactNode } from 'react';

interface ColorPaletteSingleProps {
    colorPaletteSingleContent: ReactNode;
}

export const ColorPaletteSingle = ({ colorPaletteSingleContent }: ColorPaletteSingleProps) => (
    <div className="sds_color-palette-single__container">{colorPaletteSingleContent}</div>
);
